import { Logger, loggingStateServiceKey } from '@smartsheet/logging-state-service';

export const OBSERVABILITY_STATE_SERVICE_TOKEN = loggingStateServiceKey.name;
export type IObservabilityStateService = Logger;
